import { useState, useEffect, useReducer } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { server } from "../../App";
import { Button, Grid, Form, Dropdown, Icon, Modal } from "semantic-ui-react";
import { columnDefs, topOptions } from "./GridParams/GridParams"
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { SalleOptions } from "../Consultation/bloc3/DropdownOptions/AvOptions"
import {
    initialState,
    reducer,
    ACTION,
} from "../../Reducer/InitialStateReducer"
// import moment from "moment";

const Stock = () => {
    // let date = moment().format("YYYY-MM-DD");
    const [dataFromServer, setDataFromServer] = useState([])
    const [dataFromServerProd, setDataFromServerProd] = useState([])

    const [, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [hideColumn, setHideColumn] = useState(true);
    const [SelectSalle, setSelectSalle] = useState(1);
    const [StockFromServer, setStockFromServer] = useState([]);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [showBtn, setshowBtn] = useState(true);


    const [SelectPrix, setSelectPrix] = useState();
    const [SelectquantiteFix, setquantiteFix] = useState("");
    const [SelectDate, setDate] = useState("");
    const [SelectFRS, setSelectFRS] = useState("");
    const [SelectFRSprod, setSelectFRSprod] = useState("");


    const [SelectSalle1, setSelectSalle1] = useState("");
    const [SelectPrix1, setSelectPrix1] = useState("");
    const [SelectConso1, setSelectConso1] = useState(0);
    const [SelectConso1Min, setSelectConso1Min] = useState(0);
    const [SelectquantiteFix1, setquantiteFix1] = useState("");
    const [SelectDate1, setDate1] = useState("");
    const [SelectFRSprod1, setSelectFRSprod1] = useState("");
    const [SelectidStock_Produits, setSelectidStock_Produits] = useState("");




    // const [FRSOptions, setFRSOptions] = useState({});





    const GetAllFRSprod = () => {

        return SelectFRS ?
            axios
                .get(`${server}ProduitFourniRoutes/${SelectFRS}`, {
                    headers: {
                        jwtoken: sessionStorage.token,
                    },
                })
                .then((response) => setDataFromServerProd(response.data)) : null
    };
    const GetAllFRS = () => {
        return axios
            .get(`${server}FournisseurRoutes`, {
                headers: {
                    jwtoken: sessionStorage.token,
                },
            })
            .then((response) => setDataFromServer(response.data));
    };

    useEffect(() => {

        GetAllFRS()
        GetAllFRSprod()

    }, [])
    useEffect(() => {

        // GetAllFRS()
        GetAllFRSprod()

    }, [SelectFRS])



    const getAllstock = () => {
        return axios
            .get(`${server}StockRoutes/${SelectSalle}`, {
                headers: {
                    jwtoken: sessionStorage.token,
                },
            })
            .then((response) => setStockFromServer(response.data));
    };

    useEffect(() => {
        getAllstock()
    }, [])
    useEffect(() => {
        getAllstock()
    }, [SelectSalle])


    const onGridReady = (params) => {
        setGridColumnApi(params.columnApi);
        setGridApi(params.api);
    };

    const showColumn = () => {
        gridColumnApi.setColumnsVisible(
            ["date_creationLisible", "updated_at", "nom_frs"],
            hideColumn
        );

        setHideColumn(!hideColumn);
        // to fit the size of column FIX COLUMN BUG
        // gridApi.sizeColumnsToFit();
    };


    let datatosend = {
        Fk_id_Prod_Frs: SelectFRSprod,
        date_peromption: SelectDate,
        prix: SelectPrix,
        quantiteFix: SelectquantiteFix,
        SelectSalle: SelectSalle
    }



    const CreateOneFRS = () => {

        return datatosend.Fk_id_Prod_Frs ? axios({
            method: "POST",
            responseType: "json",
            url: `${server}StockRoutes`,
            data: datatosend,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                toast.success("Successfully created", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setStockFromServer(response.data)
                setSelectPrix("")
                setquantiteFix("")
                setDate("")
                setSelectFRSprod("")

                return response;
            })
            .catch(() =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            ) : null
    };


    const listFRS = dataFromServer.map((item) => (
        { key: item.id_frs, text: item.nom_frs, value: item.id_frs }
    ))
    const listFRSprod = dataFromServerProd.map((item) => (
        { key: item.idProduits_Fournisseurs, text: item.nom_Produits_Frs, value: item.idProduits_Fournisseurs }
    ))

    const onSelectionChanged = (e) => {
        if (e.api.getSelectedRows()[0] === undefined) {
            const emptyCheckbox = {
                Fk_id_Prod_Frs: "",
                archive: "",
                consommation: "",
                date_creation: "",
                date_creationLisible: "",
                date_peromption: "",
                date_peromptionLisible: "",
                enCours: "",
                fk_id_Frs: "",
                idProduits_Fournisseurs: "",
                idStock_Produits: "",
                id_frs: "",
                nom_Produits_Frs: "",
                nom_frs: "",
                prix: "",
                quantiteFix: "",
                tel_frs: "",
                tel_frs2: "",
                terminee: "",
                updated_at: ""
            };
            setSelectidStock_Produits(emptyCheckbox.idStock_Produits)
            setSelectPrix1(emptyCheckbox.prix)
            setSelectConso1(emptyCheckbox.consommation)
            setquantiteFix1(emptyCheckbox.quantiteFix)
            setDate1(emptyCheckbox.date_peromption)
            // setSelectFRS1(emptyCheckbox.fk_id_Frs)
            setSelectFRSprod1(emptyCheckbox.Fk_id_Prod_Frs)


            setshowBtn(true)
        } else {
            let clientArray = e.api.getSelectedRows()[0];

            if (clientArray.archive == 1) {
                setSelectSalle1(3)
            } else if (clientArray.terminee == 1) {
                setSelectSalle1(2)
            } else {
                setSelectSalle1(1)
            }
            setSelectidStock_Produits(clientArray.idStock_Produits)
            setSelectPrix1(clientArray.prix)
            setSelectConso1(clientArray.consommation)
            setquantiteFix1(clientArray.quantiteFix)
            setDate1(clientArray.date_peromption)
            // setSelectFRS1(clientArray.fk_id_Frs)
            setSelectFRSprod1(clientArray.Fk_id_Prod_Frs)

            setshowBtn(false)
        }
    };

    const updatehandler = async () => {
        let data = {
            SelectSalle1: SelectSalle1,
            SelectSalle: SelectSalle,
            Fk_id_Prod_Frs: SelectFRSprod1,
            date_peromption: SelectDate1,
            prix: SelectPrix1,
            quantiteFix: SelectquantiteFix1,
            consommation: parseInt(SelectConso1) + parseInt(SelectConso1Min)

        }

        return SelectFRSprod1 ? await axios({
            method: "PUT",
            responseType: "json",
            url: `${server}StockRoutes/${SelectidStock_Produits}`,
            data: data,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setStockFromServer(response.data)
                toast.success("Success", {
                    position: toast.POSITION.TOP_CENTER,
                });

            })
            .catch((err) =>
                toast.error("error", {
                    position: toast.POSITION.TOP_CENTER,
                })
            ) : null
    };

    const deletehandler = async () => {
        await axios({
            method: "delete",
            responseType: "json",
            url: `${server}StockRoutes/${SelectidStock_Produits}/${SelectSalle}`,
            headers: {
                jwtoken: sessionStorage.token,
            },
        })
            .then((response) => {
                setStockFromServer(response.data)
                setshowBtn(true)
            })
            .catch((err) =>
                toast.error("Je ne peux pas supprimer", {
                    position: toast.POSITION.TOP_CENTER,
                })
            );
    };


    return (
        <>
            <h1 className="titrePatient">Pharmacie</h1>
            <Grid columns="equal" centered className="fixWidth3">
                <Grid.Row className="emptyPadding">
                    <Form.Field
                        className="SomeMargin"
                        value={SelectSalle}
                        search
                        selection
                        // fluid
                        // label="Salle :"
                        control={Dropdown}
                        options={SalleOptions}
                        onChange={(e, data) => {
                            setSelectSalle(data.value);
                        }}
                    />
                </Grid.Row>
                <Grid.Row className="NonPaddingBotom">
                    <Link to="/Fournisseurs">
                        <Button icon labelPosition='left' className="IconFixDopdown" color="black">
                            <Icon name='book' size='large' />
                            Fournisseurs
                        </Button>
                    </Link>













                    <Button
                        style={{
                            // paddingLeft: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="green"
                        onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
                    >
                        <Icon name='add' size='large' />
                        Ajouter
                    </Button>
                    <Modal
                        size={state.size}
                        open={state.open}
                        onClose={() => dispatch({ type: ACTION.CLOSE })}
                    >
                        <Modal.Header>Ajouter des stocks</Modal.Header>
                        <Modal.Content>
                            <Form onSubmit={CreateOneFRS}>
                                <Form.Group widths='equal'>
                                    <Form.Field>
                                        <Form.Field
                                            value={SelectFRS}
                                            required
                                            className="SomeMargin"
                                            search
                                            selection
                                            // fluid
                                            placeholder="Fournisseur"
                                            label="Fournisseur"
                                            control={Dropdown}
                                            options={listFRS}
                                            onChange={(e, data) => {
                                                setSelectFRS(data.value);
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Field
                                            value={SelectFRSprod}
                                            required
                                            className="SomeMargin"
                                            search
                                            selection
                                            // fluid
                                            placeholder="Produit"
                                            label="Produit"
                                            control={Dropdown}
                                            options={listFRSprod}
                                            onChange={(e, data) => {
                                                setSelectFRSprod(data.value);
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label >Date de péremption</label>
                                        <input
                                            value={SelectDate}
                                            required
                                            type="date"
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </Form.Field>


                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field required>
                                        <label >Quantité</label>
                                        <input
                                            value={SelectquantiteFix}
                                            placeholder="Quantité"
                                            required
                                            type="number"
                                            onChange={(e) => setquantiteFix(e.target.value)}
                                        />
                                    </Form.Field>

                                    <Form.Field required>
                                        <label >Prix</label>
                                        <input
                                            value={SelectPrix}
                                            required
                                            type="number" placeholder='Prix'

                                            onChange={(e) => setSelectPrix(e.target.value)}
                                        />
                                    </Form.Field>


                                </Form.Group>
                                <Button style={{ marginBottom: "1rem" }} floated="right" positive type="submit">
                                    Valider
                                </Button>
                                <Button floated="right" color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
                                    Retour
                                </Button>


                            </Form>
                        </Modal.Content>
                        {/* <Modal.Actions>

                            <Button positive type="submit">
                                Valider
                            </Button>
                        </Modal.Actions> */}
                    </Modal>



















                    <Button
                        disabled={showBtn}
                        style={{
                            // paddingLeft: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="blue"
                        onClick={() => dispatch({ type: ACTION.OPEN2, size2: "small" })}
                    >
                        <Icon name='pencil' size='large' />
                        Modifier
                    </Button>
                    <Modal
                        size={state.size2}
                        open={state.open2}
                        onClose={() => { setSelectConso1Min(0); dispatch({ type: ACTION.CLOSE2 }) }}
                    >
                        <Modal.Header>Modifier un stock</Modal.Header>
                        <Modal.Content>
                            <Form onSubmit={updatehandler}>
                                <Form.Group widths='equal'>
                                    {/* <Form.Field>
                                        <Form.Field
                                            value={SelectFRS1}
                                            required
                                            className="SomeMargin"
                                            search
                                            selection
                                            // fluid
                                            placeholder="Fournisseur"
                                            label="Fournisseur"
                                            control={Dropdown}
                                            options={listFRS}
                                            onChange={(e, data) => {
                                                setSelectFRS1(data.value);
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Field
                                            value={SelectFRSprod1}
                                            required
                                            className="SomeMargin"
                                            search
                                            selection
                                            // fluid
                                            placeholder="Produit"
                                            label="Produit"
                                            control={Dropdown}
                                            options={listFRSprod}
                                            onChange={(e, data) => {
                                                setSelectFRSprod1(data.value);
                                            }}
                                        />
                                    </Form.Field> */}
                                    <Form.Field required>
                                        <label >Conso</label>
                                        <input
                                            value={SelectConso1Min}
                                            placeholder="Conso"
                                            required
                                            type="number"
                                            onChange={(e) => setSelectConso1Min(e.target.value)}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        className="SomeMargin"
                                        value={SelectSalle1}
                                        search
                                        selection
                                        // fluid
                                        label="Salle "
                                        control={Dropdown}
                                        options={SalleOptions}
                                        onChange={(e, data) => {
                                            setSelectSalle1(data.value);
                                        }}
                                    />
                                    <Form.Field required>
                                        <label >Date de péremption</label>
                                        <input
                                            value={SelectDate1}
                                            required
                                            type="date"
                                            onChange={(e) => setDate1(e.target.value)}
                                        />
                                    </Form.Field>


                                </Form.Group>
                                <Form.Group widths='equal'>
                                    <Form.Field required>
                                        <label >Quantité</label>
                                        <input
                                            value={SelectquantiteFix1}
                                            placeholder="Quantité"
                                            required
                                            type="number"
                                            onChange={(e) => setquantiteFix1(e.target.value)}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label >Conso Total</label>
                                        <input
                                            value={parseInt(SelectConso1) + parseInt(SelectConso1Min)}
                                            placeholder="Conso"
                                            required
                                            type="number"
                                            onChange={(e) => setSelectConso1(e.target.value)}
                                        />
                                    </Form.Field>

                                    <Form.Field required>
                                        <label >Prix</label>
                                        <input
                                            value={SelectPrix1}
                                            required
                                            type="number" placeholder='Prix'

                                            onChange={(e) => setSelectPrix1(e.target.value)}
                                        />
                                    </Form.Field>



                                </Form.Group>
                                <Button style={{ marginBottom: "1rem" }} floated="right" positive type="submit">
                                    Valider
                                </Button>
                                <Button floated="right" color="blue" onClick={() => { setSelectConso1Min(0); dispatch({ type: ACTION.CLOSE2 }) }}>
                                    Retour
                                </Button>


                            </Form>
                        </Modal.Content>
                        {/* <Modal.Actions>

                            <Button positive type="submit">
                                Valider
                            </Button>
                        </Modal.Actions> */}
                    </Modal>






                    <Button
                        disabled={showBtn}
                        onClick={deletehandler}
                        style={{
                            // paddingLeft: "0.8rem",
                            paddingRight: "0.8rem",
                            paddingBottom: "0.5rem",
                            marginBottom: " 0.3rem"
                        }}
                        color="red">  <Icon name='delete' size='large' />Supprimer</Button>










                </Grid.Row>
            </Grid>
            <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                    height: "80vh",
                    width: "100%",
                    flex: "1 1 auto",
                }}
            >
                <AgGridReact
                    rowData={StockFromServer}
                    animateRows={true}
                    sortingOrder={["desc", "asc", null]}
                    onGridReady={onGridReady}
                    columnDefs={columnDefs}
                    rowSelection={"single"}
                    onSelectionChanged={onSelectionChanged}
                    gridOptions={topOptions}
                //   onRowDoubleClicked={onRowDoubleClicked}
                ></AgGridReact>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
            <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} />
        </>
    )
}
export default Stock